import { render, staticRenderFns } from "./HistoricoLicencas.vue?vue&type=template&id=697df19d&scoped=true&"
import script from "./HistoricoLicencas.vue?vue&type=script&lang=js&"
export * from "./HistoricoLicencas.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoLicencas.vue?vue&type=style&index=0&id=697df19d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697df19d",
  null
  
)

export default component.exports